module.exports = __webpack_public_path__ + "static/media/potential-1.69613e8f.svg";